module.exports = __webpack_public_path__ + "static/media/fba.24bfc13f.jpeg";